<template>
  <div class="notices">
    <app-notice v-for="notice in notices" :key="notice.timestamp.getTime()"
      v-bind:timestamp="notice.timestamp"
      v-bind:type="notice.type"
      v-bind:text="notice.text"
      v-bind:delay="notice.delay"
      v-on:noticeClose="removeNotification(notice.timestamp)">
    </app-notice>
  </div>
</template>

<script>
import AppNotice from './AppNotice.vue'

export default {
  name: 'AppNotices',
  data () {
    return {
      notices: this.$notices.state
    }
  },
  methods: {
    removeNotification (timestamp) {
      this.$notices.remove(timestamp)
    },
    clearNotifications () {
      this.$notices.clear()
    }
  },
  components: {
    AppNotice
  }
}
</script>

<style lang="scss">
.notices {
  position: fixed;/*relative*/
  margin: 1em;
  background: #F9F9F9;
  /* if fixed then */
  width: 500px;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0);
  /* endif */
}
</style>



// WEBPACK FOOTER //
// src/components/ui/AppNotices.vue